module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training-elite-50.6a3c8602.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training-elite-50.png
// module id = 3807
// module chunks = 11